import { render } from "./PageStyleComponent.vue?vue&type=template&id=def79c56"
import script from "./PageStyleComponent.vue?vue&type=script&lang=js"
export * from "./PageStyleComponent.vue?vue&type=script&lang=js"

import "./PageStyleComponent.vue?vue&type=style&index=0&id=def79c56&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__